import ComingSoonPage from '@/components/feature/ComingSoonPage';

export default function Page403() {
  return (
    <ComingSoonPage
      title="无访问权限"
      description="您没有权限访问该页面。如需帮助，请联系平台客服或返回首页。"
      icon="ri-shield-cross-line"
      backHref="/"
      backLabel="返回首页"
    />
  );
}